import { trigger, transition, style, animate } from '@angular/animations';
import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxMatIntlTelInputComponent } from 'ngx-mat-intl-tel-input';
import { NotificationService } from 'src/app/services/notification.service';
import { TabControlService } from 'src/app/services/tab-control.service';
import { removeBase64Prefix } from 'src/app/util/Helper';
import { environment } from 'src/environments/environment';
import * as Constants from "src/app/constants/constants";
import { ApiService } from 'src/app/services/api/api.service';
import { EstateControlService } from 'src/app/services/estate-control.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../modal/modal.component';
import { FileCompressionService } from 'src/app/services/file-compression.service';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate('300ms', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
    trigger('bounceIn', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0.5)' }),
        animate('300ms', style({ opacity: 1, transform: 'scale(1)' })),
      ]),
    ]),
  ],
})
export class InputComponent implements OnInit, OnChanges {
  @ViewChild('modalContent') modalContent!: TemplateRef<any>;

  @ViewChild('phoneInput')
  phoneInput!: NgxMatIntlTelInputComponent;

  @Input()
  controlName!: string;
  @Input()
  formGroup!: FormGroup;
  @Input()
  validationMessages: any;
  @Input()
  formErrors: any;

  @Input() loadingOptions: boolean = false;
  @Input() altIDSuggest: boolean = false;

  @Input()
  selectFunction: (param: any) => void = () => {};
  @Input()
  selectParam: any;

  @Input()
  fileFunction: (param: any) => void = () => {};

  @Input() runSuggestions: boolean = false;
  @Input()
  suggestFunction: (param1: 'ID' | 'NAME', param2: string) => void = () => {};
  @Input()
  suggestID: (param1: number, param2: string) => void = () => {};
  @Input()
  suggestIndex: number = 0;

  @Input() inputType: string = 'normal';  // options : normal / select / multi-select / phone / date / area / file / view / auto-complete

  @Input() useFileURL: boolean = false;
  @Input() fileURL: string | null = null;

  @Input() type: string = 'text';
  @Input() label: string = 'label';
  @Input() hint: string = '';
  @Input() subtext: string = '';
  @Input() required: 'true' | 'false' = 'true';

  @Input() ArrayItems: any = ['Option one', 'Option two'];

  @Input() weekdaysOnly: boolean = false;
  @Input() includeSaturdays: boolean = false;

  @Input() enforceVirtualOfficeHours: boolean = false;
  @Input() enforcePhysicalOfficeHours: boolean = false;
  @Input() selectedVirtualOfficeDay: string = '';

  @Input() phoneError: string = '';

  @Input() maxDate: any = '';
  @Input() minDate: any = '';

  @Input() existingFileName: string = '';
  @Input() timeFunction: (param: any) => void = () => {}
  
  @Input() validationID: any = null;
  @Input() currentRecord: any = null;

  @Input() shareIndex: number = 0;

  // @Output() file: EventEmitter<any> = new EventEmitter<any>();

  inputFocused: boolean = false;
  inputTouched: boolean = false;
  fileName: string = 'No file chosen';
  fileValid: boolean = false;
  validatingFile: boolean = false;

  filteredArray: any = [];

  time: string = '';
  ampm: 'AM' | 'PM' = 'AM';
  minHours: number = 8;
  maxHours: number  = 6;

  service: TabControlService | EstateControlService = this.tabControlService;
  isEstatePlanning: boolean = false;

  // //// IMAGE CAPTURE SECTION:

  previewImage: string | null = null;
  isImage: boolean = false;


  constructor(
    private readonly tabControlService: TabControlService,
    private readonly estateControlService: EstateControlService,
    private readonly notificationService: NotificationService,
    private readonly apiService: ApiService,
    private readonly dialog: MatDialog,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef,
    private readonly compressionService: FileCompressionService,
    private readonly toastr: ToastrService
    ) {
    }


  ngOnInit(): void {
    if (this.router.url.includes('estate-planning')) {
      this.service = this.estateControlService;
      this.isEstatePlanning = true;
    }

    if (!(this.existingFileName === '' || this.existingFileName === null)) {
      this.fileName = this.existingFileName;
      this.fileValid = true;
    }

    if (this.inputType === 'time') {
      const formControl = this.formGroup.get(this.controlName);
      if (formControl) {
        formControl.valueChanges.subscribe((value) => {
          if (value) {
            const newValue = value.replace(/[^0-9:]/g, '');

            if (newValue.length >=2) {
              const [hours, minutes] = newValue.split(':');
              let formattedHours = Number.parseInt(newValue);
              let formattedMins = minutes;

              if (newValue.length > 3) {
                formattedHours = Number.parseInt(hours);
                
                if (Number.parseInt(minutes) >= 60) {
                  formattedMins = '00';
                }
              }

              if (formattedHours >= 12) {
                if (formattedHours > 12) {
                  formattedHours -= 12;
                } else {
                  formattedHours = 12;
                }
                this.ampm = 'PM';
              } else if (formattedHours === 0) {
                this.ampm = 'AM';
              }
              
              // Enforce Virtual Office Hours
              if (this.enforceVirtualOfficeHours) {
                if (this.selectedVirtualOfficeDay === 'Saturday') {
                  this.minHours = 9;
                  this.maxHours = 1;
                } else {
                  this.minHours = 8;
                  this.maxHours = 6;
                }

                if (this.ampm === 'AM' && formattedHours < this.minHours) {
                  formattedHours = this.minHours;
                  this.ampm = 'AM';
                } else if (this.ampm === 'PM' && formattedHours > this.maxHours && formattedHours != 12) {
                  formattedHours = this.maxHours;
                  this.ampm = 'PM';
                }
              }
              
              // Enforce Physical Office Hours
              if (this.enforcePhysicalOfficeHours) {
                if (this.ampm === 'AM' && formattedHours < 8) {
                  formattedHours = 8;
                } else if (this.ampm === 'PM' &&
                 (
                  formattedHours > 4 ||
                  formattedHours >= 4 &&
                  newValue.length > 3 && Number.parseInt(minutes) > 30
                 )
                ) {
                  if (formattedHours != 12) formattedHours = 4;

                  if (formattedHours == 4 && newValue.length > 3 && Number.parseInt(minutes) > 30) formattedMins = '30';
                }
              }
              
              this.timeFunction(this.ampm);

              if (formattedMins === undefined) {
                formattedMins = '00';
              }
              
              this.time = newValue.length === 2 ?
                `${formattedHours.toString().padStart(2, '0')}:` :
                `${formattedHours.toString().padStart(2, '0')}:${formattedMins}`;
              
              formControl.patchValue(this.time, { emitEvent: false });
            }
          }
        });
      }
    }

    setTimeout(() => {
      if (this.formControl?.invalid) {
        this.cdr.detectChanges();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    // Listen for changes in the formGroup and controlName inputs
    if ('formGroup' in changes && 'controlName' in changes) {
      const formControl = this.formGroup.get(this.controlName);

      // Subscribe to value changes of the form control
      if (formControl) {
        formControl.valueChanges.subscribe((newValue) => {
          // Capitalize the value before patching it back to the form control
          if (formControl.touched) {
            this.inputTouched = true;
          }
          
          if (this.inputType !== 'file' && typeof newValue === 'string') {
            let newControlValue;
            if (this.controlName.toLowerCase() === 'krapin' || this.controlName.toLowerCase() === 'idno' || this.controlName.toLowerCase() === 'receipt') {
              newControlValue = newValue.replace(/[^A-Z0-9\s]/gi, '').replace(/[a-z]/g, (match) => match.toUpperCase());
              formControl.patchValue(newControlValue, { emitEvent: false });
              
              if (this.runSuggestions && this.controlName.toLowerCase() === 'idno') {
                if (this.altIDSuggest) this.suggestID(this.suggestIndex, newValue);
                else this.suggestFunction('ID', newValue);
              }

            } else {
              if (this.controlName.toLowerCase().includes('name')) {
                newControlValue = newValue
                  // Allow letters, numbers, spaces, apostrophes, commas, and dashes
                  .replace(/[^A-Z0-9\s',-]/gi, '')
                  // Convert to Title Case
                  .replace(/\b\w+/g, word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                  // Capitalize the first letter after spaces and periods
                  .replace(/(^\w)|([\s.]\s*\w)/g, match => match.toUpperCase());

                formControl.patchValue(newControlValue, { emitEvent: false });

              } else if (this.controlName.toLowerCase().includes('address') || this.controlName.toLowerCase() == 'location') {
                newControlValue = newValue
                // Allow letters, numbers, spaces, periods, dashes, and commas
                .replace(/[^A-Z0-9\s.,-]/gi, '')
                // Split into words based on spaces, periods, commas, and dashes
                .split(/([\s.,-]+)/)
                .map((word, index, array) => {
                  // Check if the word is longer than 4 letters
                  if (word.length > 4) {
                    // Convert to title case (first letter uppercase, rest lowercase)
                    word = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
                  } else if (index === 0 || /[\s.,-]/.test(array[index - 1])) {
                    // Capitalize the first letter after spaces, periods, commas, or dashes
                    word = word.charAt(0).toUpperCase() + word.slice(1);
                  }
                  return word;
                })
                .join('');
                formControl.patchValue(newControlValue, { emitEvent: false });

              } else if (this.controlName.toLowerCase().includes('email')) {
                newControlValue = newValue.toLowerCase();
                formControl.patchValue(newControlValue, { emitEvent: false });

              } else if (this.inputType.toLowerCase() == 'area') {
                newControlValue = newValue.replace(/[^A-Z0-9\s]/gi, '').replace(/(^\w)|(\.\s*\w)/g, match => match.toUpperCase()); // Capitalze after periods
                formControl.patchValue(newControlValue, { emitEvent: false });
                
              } else if ( // Exclude these three and act on every other control
                !(this.inputType.toLowerCase().includes('select')
                  || this.inputType.toLowerCase().includes('complete')
                  || this.inputType.toLowerCase().includes('phone')
                )
              ) {
                // Replace your existing exclusion condition block with this cleaner check:
                const isAutocomplete = this.inputType === 'auto-complete' || this.inputType.toLowerCase().includes('complete');

                if (!isAutocomplete && !this.inputType.toLowerCase().includes('select') && !this.inputType.toLowerCase().includes('phone')) {
                  if (this.controlName.toLowerCase() === 'distributionage') {
                    newControlValue = newValue.replace(/^0+|[^0-9]/g, '');
                  } else {
                    newControlValue = newValue
                      .replace(/[^A-Z0-9\s]/gi, '')
                      .toLowerCase()
                      .split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' ');
                  }
                  formControl.patchValue(newControlValue, { emitEvent: false });  
                }  
              }

              if (this.runSuggestions && this.controlName.toLowerCase() === ('firstname')) {
                  this.suggestFunction('NAME', newValue);
              }

            }
          }
        });
      }
    }
  }

  get formControl() {
    return this.formGroup.get(this.controlName);
  }

  get settlorType(): number {
    return this.tabControlService.settlorType;
  }

  isDragOver: boolean = false;

  onInputFocus(): void {
    this.inputFocused = true;
    if (this.inputType == 'auto-complete') this.filter(this.formControl?.value || '');
    if (this.controlName === 'PercShare') {
      const ben = this.tabControlService.beneficiaries[this.shareIndex];
      if (ben.BeneficiaryID) this.tabControlService.sharesRemaining += Number(ben.PercShare);
    }
  }

  onInputBlur(): void {
    if (this.controlName === 'PercShare') {
      const ben = this.tabControlService.beneficiaries[this.shareIndex];
      this.tabControlService.sharesRemaining = this.tabControlService.finalSharesRemaining;
      
      if (!this.formControl?.value || this.formControl?.value == '' || this.formControl?.value == '0') {
        if (ben.BeneficiaryID) {
          this.formControl?.setValue(ben.PercShare);
          this.notificationService.viewToast(
            'info',
            `Share allocation reverted`,
            `${
              this.formGroup.get('Category')?.value === this.tabControlService.BeneficiaryOptions[1] ?
              (this.formGroup.get('InstitutionName')?.value == '' ? 'Institution Beneficiary' : this.formGroup.get('InstitutionName')?.value) :
              (this.formGroup.get('FirstName')?.value == '' ? 'Individual Beneficiary' : (this.formGroup.get('FirstName')?.value +' '+ this.formGroup.get('LastName')?.value ))
            } still has ${this.formControl?.value} shares`
          )
        }
      
      } else {
        const percentage = Number.parseInt(this.formControl?.value);
        if (ben.BeneficiaryID) this.tabControlService.updateRemainingShares(percentage, Number(ben.PercShare));
        else this.tabControlService.updateRemainingShares(percentage);

        if (!ben.BeneficiaryID || ben.BeneficiaryID && ben.PercShare !== this.formControl?.value) {
          this.notificationService.viewToast(
            'info',
            `${
              this.formGroup.get('Category')?.value === this.tabControlService.BeneficiaryOptions[1] ?
              (this.formGroup.get('InstitutionName')?.value == '' ? 'Institution Beneficiary' : this.formGroup.get('InstitutionName')?.value) :
              (this.formGroup.get('FirstName')?.value == '' ? 'Individual Beneficiary' : (this.formGroup.get('FirstName')?.value +' '+ this.formGroup.get('LastName')?.value ))
            } assigned ${this.formControl?.value} shares`,
            (this.tabControlService.sharesRemaining > 0 ? `You now have ${this.tabControlService.sharesRemaining} shares unassigned.` : 'All shares assigned')
          )
        }
        
      }
      if (!environment.production) {
        console.log('Current Remaining shares: ', this.tabControlService.sharesRemaining
        )}
    }
    if (this.inputType === 'auto-complete') {
      // Wrap inside a timeout to allow mat-option selection to finalize first
      setTimeout(() => {
        this.filter(this.formControl?.value || '');
        const value = this.formControl?.value?.toString().toLowerCase() || '';
        let foundValue = '';

        this.filteredArray.some((item: any) => {
          let checkItem: any = item.Description;
          if (this.isLocalInput()) checkItem = item;
          if (this.isTitle()) checkItem = item.Title;
          if (this.isCountry()) checkItem = item.CountryName;
          if (this.isCounty()) checkItem = item.CountyName;
          if (this.isNationality()) checkItem = item.Nationality;
          if (this.isBank() || this.isBankBranch()) checkItem = item.ID;

          if (checkItem && checkItem.toString().toLowerCase() === value) {
            foundValue = checkItem;
            return true; // Break the array some iteration loop
          }
          return false;
        });

        if (foundValue === '') {
          this.formControl?.setValue('', { emitEvent: false });
        } else {
          this.formControl?.setValue(foundValue, { emitEvent: false });
        }
      }, 200); // 200ms delay protects option click selection streams
    }

    this.inputFocused = false;
    this.inputTouched = true;
    if (this.formControl) {
      this.formControl.updateValueAndValidity();
      this.cdr.detectChanges();
    }
  }

  shouldShowErrors(): boolean {
    return this.formControl?.invalid 
      && (this.formControl?.touched || this.formControl?.dirty)
      || false;
  }

  getControlLabel() {
    let label = '';
    
    switch (this.controlName?.toLowerCase()) {  
      case 'email':
        label = 'email';
        break;
      case 'phone':
        label = 'phone number';
        break;
      case 'idno':
        label = 'ID number';
        break;
      case 'krapin':
        label = 'PIN number';
        break;
    }

    return label;
  }

  loggedErrors = new Set<string>();
  index = 1;
  getCurrentErrorMessage(): string {
    if (!this.formControl?.errors) return '';

    const label = this.getControlLabel();
    // Check for custom validator errors first
    if (this.formControl.errors['exist']) {
      return `This ${label} already exists`;
    }

    // Handle the library's built-in validation
    if (this.formControl?.errors['validatePhoneNumber']) {
      return 'Invalid phone number';
    }
    
    // Check for standard validation errors
    if (this.formControl.errors['required']) return 'Required field';
    if (this.formControl.errors['email']) return 'Invalid email format';
    if (this.formControl.errors['pattern']) return `Invalid ${label} format`;
    
    // Fallback to formErrors if available
    if (this.formErrors[this.controlName]) {
      return this.formErrors[this.controlName];
    }
    
    return `Invalid ${label}`;
  }
  // Autocomplete
  filter(inputValue?: string): void {
    if (this.ArrayItems.length > 0) {
      this.filteredArray = [];
      
      // Fall back to control value only if inputValue isn't explicitly passed (like on focus)
      const filterValue = (inputValue ?? (this.formControl?.value || '')).toLowerCase();

      console.log('Captured Filter Value:', filterValue); // This will now accurately log

      for (const element of this.ArrayItems) {
        const item = element;
        let checkItem: any = item.Description;
        if (this.isLocalInput()) checkItem = item;
        if (this.isTitle()) checkItem = item.Title;
        if (this.isCountry()) checkItem = item.CountryName;
        if (this.isCounty()) checkItem = item.CountyName;
        if (this.isNationality()) checkItem = item.Nationality;
        if (this.isBank() || this.isBankBranch()) checkItem = item.ID;

        if (checkItem?.toString().toLowerCase().startsWith(filterValue)) {
          this.filteredArray.push(item);
        }
      }
    }
  }
  trackByFn(index: number, option: any): string {
    return option.Description;
  }

  capitalizeOption(option: string): string {
    try {
      const upper = option.toUpperCase();
      return upper;
    } catch(error) {
      console.log('Error capitalizing input ', error);
      return option;
    }
  }

  isPdfOrImg(fileName: string, includePDF: boolean = true): boolean {
    let allowedExtensions = ['.jpg', '.jpeg', '.png'];
    if (includePDF) allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];

    const ext = fileName.toLowerCase().substr(fileName.lastIndexOf('.'));
    return allowedExtensions.includes(ext);
  }

  onSelectionChange() {
    if (this.inputType === 'select') {
      this.selectFunction(this.selectParam); // Trigger the parent component's function
    }
  }

  onFileValid(fileName: string, base64: string | null): void {
    try {
      const object = {
        name: fileName,
        stringValue: base64
      };
      this.fileFunction(object);

    } catch (error) {
      console.log('!! File updater error : ', error);
    }
  }

  isLocalInput(): boolean {
    if (
      this.controlName === 'PaymentMode' ||
      this.controlName === 'referree' ||
      this.controlName === 'Category' ||
      this.controlName === 'Gender' ||
      this.controlName === 'HowDidYouHearUS' ||
      this.controlName === 'Relationship' ||
      this.controlName === 'Mortgage' ||
      this.controlName === 'AccountType' ||
      this.controlName === 'FinancierType' ||
      this.controlName === 'Ownership' ||
      this.controlName === 'Currency'
    ) {
      return true;
    }
    return false;
  }

  isTitle(): boolean {
    if (
      this.controlName === 'Title'
    ) {
      return true;
    }
    return false;
  }

  isCountry(): boolean {
    if (
      this.controlName === 'Country'
    ) {
      return true;
    }
    return false;
  }

  isCounty(): boolean {
    if (
      this.controlName === 'County'
    ) {
      return true;
    }
    return false;
  }

  isNationality(): boolean {
    if (
      this.controlName === 'Nationality'
    ) {
      return true;
    }
    return false;
  }

  isBank(): boolean {
    if (
      this.controlName.toLowerCase() === 'bank'
    ) {
      return true;
    }
    return false;
  }
  isBankBranch(): boolean {
    if (
      this.controlName.toLowerCase() === 'bankbranch'
    ) {
      return true;
    }
    return false;
  }

  // UNUSED! Clears PercShare control for beneficiaries
  clearShares() {
    if (!environment.production) console.log(this.formGroup.value)
    const ben = this.tabControlService.beneficiaries[this.shareIndex];

    if (!this.inputFocused) this.tabControlService.sharesRemaining = this.tabControlService.finalSharesRemaining;
    if (!ben.BeneficiaryID) this.tabControlService.undoShareAssignment(Number.parseInt(this.formControl?.value));
    
    this.notificationService.viewToast(
      'error',
      `${this.formControl?.value} Shares cleared`,
      `${
        this.formGroup.get('Category')?.value === this.tabControlService.BeneficiaryOptions[1] ?
        (this.formGroup.get('InstitutionName')?.value == '' ? 'Institution Beneficiary' : this.formGroup.get('InstitutionName')?.value) :
        (this.formGroup.get('FirstName')?.value == '' ? 'Individual Beneficiary' : (this.formGroup.get('FirstName')?.value +' '+ this.formGroup.get('LastName')?.value ))
      }`
    )

    this.formControl?.setValue('');

    setTimeout(()=> {
      if (!ben.BeneficiaryID)
        this.notificationService.viewToast('info',
          `You now have ${this.tabControlService.sharesRemaining} shares remaining.`,
          'Please note you have to assign all shares in order to proceed'
        )
    }, 1000)
  }

  // Filter function to disable weekends
  dateFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.

    if (this.includeSaturdays) {
      return day !== 0;
    } else {
      return day !== 0 && day !== 6;
    }
  };

  onTimeChange(event: any): void {
    this.ampm = event.value;
    this.timeFunction(this.ampm);

    const formControl = this.formGroup.get(this.controlName);
    if (formControl) {
      formControl.setValue('');
    }
  }

  openSavedDoc(): void {
    if (this.fileURL) {
      window.open(this.fileURL, "_blank");    
    }
  }

  enableSelectImage(): void {
    this.useFileURL = false;
    const formControl = this.formGroup.get(this.controlName);
    if (formControl) {
      formControl.setValue('');
    }
  }

  

  async openImageDialog(event: any): Promise<void> {
    try {
      const file = event.target.files[0];
      if (!file) return;

      const fileName = file.name;
      this.fileName = 'Processing attachment...';
      this.cdr.detectChanges();

      let workFile: File;
      try {
        // Run file validation and lossy canvas compression through our service layer
        workFile = await this.compressionService.processFile(file);
      } catch (validationError: any) {
        // Catches unoptimizable or oversized documents (e.g. PDFs > 1MB)
        this.fileName = 'File too large!';
        this.fileValid = false;
        this.formControl?.setValue(null);
        this.notificationService.viewToast('error', 'Attachment rejected', validationError.message || 'File violates size threshold constraints.');
        event.target.value = ''; // Reset input element state
        return;
      }

      this.isImage = this.isPdfOrImg(fileName, false);

      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = reader.result ? reader.result.toString().split(',')[1] : null;
        
        if (this.isPdfOrImg(fileName)) {
          if (base64String) {
            this.fileName = fileName;
            this.fileValid = true;

            const fileType = workFile.type;
            if (this.isImage) {
              this.previewImage = `data:${fileType};base64,${base64String}`;
            } else {
              this.previewImage = `data:application/pdf;base64,${base64String}`;
            }
            
            // Set value to formControl and sync with parent templates
            this.onFileValid(workFile.name, base64String);
            this.formControl?.setValue(base64String);
            this.cdr.detectChanges();
          }
        } else {
          this.fileName = 'Invalid Format!';
          this.fileValid = false;
          this.formControl?.setValue(null);
          this.notificationService.viewToast('error', 'Please upload only PDF or JPG files');
        }
      };
      
      reader.readAsDataURL(workFile);
    }
    catch (error: any) {
      console.error("OpenImage Exception: ", error);
      this.fileName = 'No file chosen';
      this.notificationService.viewToast('error', 'File processing error occurred.');
    }
  }

  async validateDocument(file: string): Promise<boolean> {
    this.toastr.clear();
    this.validatingFile = true;
    this.notificationService.isValidatingFile(true);
    let record = '';

    if (this.currentRecord) {
      record = this.currentRecord;
    } else {
      switch (this.service.activeTab) { // First case is milele trust
        case 1:
          record = 'Settlor';
          if (this.isEstatePlanning && this.estateControlService.planType == 1) record = 'Testator';
          break;
        case 3:
          record = 'Beneficiary';
          if (this.isEstatePlanning && this.estateControlService.planType == 1) record = 'Executor';
          break;
        case 4:
          record = 'Guardian';
          break;
        case 5:
          record = 'Trustee';
          if (this.isEstatePlanning && this.estateControlService.planType == 1) record = 'Beneficiary';
          break;
        case 6:
          record = 'Enforcer';
          if (this.isEstatePlanning && this.estateControlService.planType == 1) record = 'Witness';
          break;
        default:
          break;
      }
    }
    
    try {
      const data = {
        Record: record,
        DocType:
          this.controlName.toLowerCase().includes('idno') ? 'ID' :
          this.controlName.toLowerCase().includes('krapin') ? 'PIN' : 'REGCERT',
        ValidationID: environment.production ? (this.validationID || '') : '',
        MediaUrl: file
      };

      this.fileName = `Validating attached ${data.DocType}`;

      const response =  await this.apiService.postRequest(
        environment.baseUrl + Constants.validateDocURL, data, false);
      
      this.validatingFile = false;
      this.notificationService.isValidatingFile(false);
      if (response.Status === 1) {
        return true;
      } else {
        this.notificationService.viewToast('error', 'Attachment not verified', response.Message, true);
        return false;
      }

    } catch (ex) {
      this.fileName = 'No file chosen';
      console.error('Validate Doc error : ', ex);
      this.validatingFile = false;
      this.notificationService.isValidatingFile(false);
      return false;
    }
  }

  openImageModal = (): void => {
    const dialogRef = this.dialog.open(ModalComponent, {
      minWidth: '500px',  // Default width as 100% of the screen width
      width: 'fit-content',
      maxWidth: '98%',  // Maximum width of the modal
      maxHeight: '96vh',
      data: {
        contentTemplate: this.modalContent,
        modalTitle: 'Select File'
      },
      disableClose: true // Disable closing when clicking outside the modal
    });

    this.notificationService.addModal(dialogRef);

    dialogRef.afterClosed().subscribe(() => {
      this.notificationService.removeModal(dialogRef);
    });
  }
  

  async captureImage(): Promise<void> {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      const video = document.createElement('video');
      video.srcObject = stream;
      video.style.maxHeight = '80vh';
      video.play();

      // Create a modal or a container to display the video feed
      const container = document.createElement('div');
      container.style.position = 'fixed';
      container.style.display = 'flex';
      container.style.flexDirection = 'column';
      container.style.top = '50%';
      container.style.left = '50%';
      container.style.transform = 'translate(-50%, -50%)';
      container.style.background = '#fff';
      container.style.zIndex = '1000';
      container.style.padding = '20px';
      container.style.maxHeight = '95vh';
      container.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
      container.appendChild(video);

      const captureButton = document.createElement('button');
      captureButton.textContent = 'Capture';
      captureButton.style.marginTop = '10px';
      captureButton.style.left = '16px';
      captureButton.style.bottom = '-2px';
      captureButton.style.padding = '5px';
      captureButton.style.paddingLeft = '16px';
      captureButton.style.paddingRight = '16px';
      captureButton.style.background = '#00518a';
      captureButton.style.color = 'white';
      captureButton.style.cursor = 'pointer';
      captureButton.style.borderRadius = '5px';
      container.appendChild(captureButton);

      document.body.appendChild(container);

      captureButton.onclick = () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        context?.drawImage(video, 0, 0, canvas.width, canvas.height);

        // Stop video stream and clean up
        stream.getTracks().forEach((track) => track.stop());
        container.remove();

        // Get image data
        const imageData = canvas.toDataURL('image/png');
        this.previewImage = imageData;
        this.fileName = `Captured_image-${Date.now()}.png`;
        this.fileValid = true;

        // Set value to formControl
        const base64String = removeBase64Prefix(imageData);
        this.onFileValid(this.fileName, base64String);
        this.formControl?.setValue(base64String);
      };
    } catch (error) {
      this.notificationService.viewToast('error', 'Error accessing the camera', 'Please check if your device has an accessible camera')
      console.error('Error accessing the camera:', error);
    }
  }

  removePreview(): void {
    this.previewImage = null;
    this.fileName = 'No file chosen';
    this.fileValid = false;
    this.formControl?.setValue(null);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]);
    }
  }

  async handleFile(file: File): Promise<void> {
    try {
      if (!file) return;

      const fileName = file.name;
      this.fileName = 'Processing dropped item...';
      this.cdr.detectChanges();

      let workFile: File;
      try {
        // Enforce the exact same compression/validation pipeline onto raw drag-and-drop structures
        workFile = await this.compressionService.processFile(file);
      } catch (validationError: any) {
        this.fileName = 'File too large!';
        this.fileValid = false;
        this.formControl?.setValue(null);
        this.notificationService.viewToast('error', 'Attachment rejected', validationError.message || 'File violates size threshold constraints.');
        return;
      }

      this.isImage = this.isPdfOrImg(fileName, false);

      const reader = new FileReader();
      reader.onload = async () => {
        const base64String = reader.result ? reader.result.toString().split(',')[1] : null;

        if (this.isPdfOrImg(fileName)) {
          if (base64String) {
            this.fileName = fileName;
            this.fileValid = true;

            const fileType = workFile.type;
            if (this.isImage) {
              this.previewImage = `data:${fileType};base64,${base64String}`;
            } else {
              this.previewImage = `data:application/pdf;base64,${base64String}`;
            }

            this.onFileValid(workFile.name, base64String);
            this.formControl?.setValue(base64String);
            this.cdr.detectChanges();
          }
        } else {
          this.fileName = 'Invalid Format!';
          this.fileValid = false;
          this.formControl?.setValue(null);
          this.notificationService.viewToast('error', 'Please upload only PDF or JPG files');
        }
      };

      reader.readAsDataURL(workFile);
    } catch (error: any) {
      console.error("Drag and drop file reader exception: ", error);
      this.fileName = 'No file chosen';
    }
  }
  
}
